import { gql } from "@apollo/client";

export const GET_ISSUES = gql`
  query GetIssues(
    $page: Int
    $pageSize: Int
    $status: IssueStatus
    $search: String
    $searchFields: [String!]
    $sort: String
    $currentStage: IssueStageEnum
    $application: Application
    $classification: IssueClassification
    $priority: IssuePriority
    $fetchBy: FetchBy
    $assignedTo: ID
    $createdBy: ID
  ) {
    rows: getIssues(
      page: $page
      pageSize: $pageSize
      status: $status
      search: $search
      searchFields: $searchFields
      sort: $sort
      currentStage: $currentStage
      application: $application
      classification: $classification
      priority: $priority
      fetchBy: $fetchBy
    ) {
      _id
      code
      issueBackground
      issueDetails
      issueApplication
      resolutionDetails
      action
      expectation
      attachments
      classification
      priority
      clickupTicketId
      createdBy
      createdByType
      meta {
        application
        ipAddress
      }
      status
      stages {
        escalatedTo {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            firstName
            emailAddress
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            firstName
            lastName
            emailAddress
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        escalatedToType
        user {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        userType
        notes
        stage
      }
      currentStage {
        stage
        user {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        userType
      }
      createdAt
      updatedAt
    }
    count: getIssuesCount(
      status: $status
      search: $search
      searchFields: $searchFields
      currentStage: $currentStage
      application: $application
      classification: $classification
      priority: $priority
      createdBy: $createdBy
      assignedTo: $assignedTo
      fetchBy: $fetchBy
    )
  }
`;

export const GET_ISSUE = gql`
  query GetIssue($id: ID!) {
    issue: getIssue(id: $id) {
      _id
      code
      issueBackground
      issueDetails
      issueApplication
      action
      expectation
      attachments
      resolutionDetails
      classification
      priority
      contactPerson {
        fullName
        email
        phoneNumber
      }
      clickupTicketId
      createdBy
      createdByType
      meta {
        application
        ipAddress
        userAgent
      }
      status
      stages {
        escalatedTo {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            firstName
            emailAddress
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            firstName
            lastName
            emailAddress
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        escalatedToType
        notes
        stage
        timestamp
        user {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        userType
      }
      currentStage {
        escalatedTo {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            firstName
            emailAddress
            lastName
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            firstName
            lastName
            emailAddress
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        notes
        stage
        timestamp
        user {
          ... on User {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on ContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on MeterContractorUser {
            _id
            emailAddress
            firstName
            lastName
            phoneNumber
            profileImageUrl
          }
          ... on Contractor {
            _id
            name
          }
          ... on MeterContractor {
            _id
            name
          }
        }
        userType
        escalatedToType
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_TICKET_DETAILS = gql`
  query GetTicketDetails($ticketId: String!) {
    clickupTask: getTicketDetails(ticketId: $ticketId) {
      id
      name
      status
      date_created
      date_closed  
      date_done
      creator {
        email
        id
        profilePicture
        username
      }
      tags {
        name
        tag_bg
        tag_fg
      }
      priority {
        color
        priority
      }
      project {
        id
        name
      }
    }
  }
`;

export const CREATE_ISSUE = gql`
  mutation CreateIssue(
    $issueBackground: String!
    $issueApplication: Application!
    $action: String!
    $expectation: String!
    $classification: IssueClassification!
    $priority: IssuePriority!
    $issueDetails: String!
    $attachments: [String]
    $fullName: String
    $email: String
    $phoneNumber: String
    $notes: String
  ) {
    createIssue(
      issueBackground: $issueBackground
      issueApplication: $issueApplication
      action: $action
      expectation: $expectation
      classification: $classification
      priority: $priority
      issueDetails: $issueDetails
      attachments: $attachments
      fullName: $fullName
      email: $email
      phoneNumber: $phoneNumber
      notes: $notes
    ) {
      _id
    }
  }
`;

export const REPORT_ISSUE_DIRECTLY = gql`
  mutation ReportIssueDirectly(
    $issueBackground: String!
    $action: String!
    $expectation: String! 
    $classification: IssueClassification!
    $priority: IssuePriority!
    $issueDetails: String!
    $attachments: [String]
    $notes: String
  ) {
    reportIssueDirectly(
      issueBackground: $issueBackground
      action: $action
      expectation: $expectation
      classification: $classification
      priority: $priority
      issueDetails: $issueDetails
      attachments: $attachments
      notes: $notes
    ) {
      _id
    }
  }
`;

export const REFER_ISSUE_TO_POWER_USER = gql`
  mutation ReferIssueToPowerUser($id: ID!, $notes: String!) {
    referIssueToPowerUser(id: $id, notes: $notes) {
      _id
    }
  }
`;

export const ESCALATE_ISSUE_TO_POLYMORPH = gql`
  mutation EscalateIssueToPolymorphLabs($id: ID!, $notes: String!) {
    escalateIssueToPolymorphLabs(id: $id, notes: $notes) {
      _id
    }
  }
`;

export const RESOLVE_ISSUE = gql`
  mutation ResolveIssue($id: ID!, $notes: String!) {
    resolveIssue(id: $id, notes: $notes) {
      _id
    }
  }
`;
export const REJECT_ISSUE_RESOLUTION = gql`
  mutation RejectIssue($id: ID!, $notes: String!) {
    rejectIssue(id: $id, notes: $notes) {
      _id
    }
  }
`;

export const APPROVE_ISSUE_RESOLUTION = gql`
  mutation CompleteIssue($id: ID!, $notes: String) {
    completeIssue(id: $id, notes: $notes) {
      _id
    }
  }
`;

export const GET_ISSUES_SUMMARY = gql`
  query GetIssuesSummary(
    $search: String
    $searchFields: [String!]
    $sort: String
    $status: IssueStatus
    $application: Application
    $issueApplication: Application
    $classification: IssueClassification
    $priority: IssuePriority
    $createdBy: ID
    $assignedTo: ID
    $fetchBy: FetchBy
  ) {
    summary: getIssuesSummary(
      search: $search
      searchFields: $searchFields
      sort: $sort
      status: $status
      application: $application
      issueApplication: $issueApplication
      classification: $classification
      priority: $priority
      createdBy: $createdBy
      assignedTo: $assignedTo
      fetchBy: $fetchBy
    ) {
      EscalatedToPolymorphLabs
      Completed
      ReferredToPowerUser
      Rejected
      ReportedToFocalPerson
      Resolved
      Reassigned
      ReassignedToPowerUser
      Reworking
      Start
    }
  }
`;

export const UPDATE_ISSUE = gql`
  mutation UpdateIssue(
    $id: ID!
    $issueBackground: String!
    $issueDetails: String!
    $issueApplication: Application!
    $action: String!
    $expectation: String!
    $classification: IssueClassification!
    $priority: IssuePriority!
    $attachments: [String]
    $fullName: String
    $email: String
    $phoneNumber: String
    $notes: String
  ) {
    updateIssue(
      id: $id
      issueBackground: $issueBackground
      issueDetails: $issueDetails
      issueApplication: $issueApplication
      action: $action
      expectation: $expectation
      classification: $classification
      priority: $priority
      attachments: $attachments
      fullName: $fullName
      email: $email
      phoneNumber: $phoneNumber
      notes: $notes
    ) {
      _id
    }
  }
`;

export const RE_ASSIGN_ISSUE_TO_FOCAL_PERSON = gql`
  mutation ReAssignIssueToFocalPerson(
    $issue: ID!
    $focalPerson: ID!
    $notes: String!
  ) {
    reAssignIssueToFocalPerson(
      issue: $issue
      focalPerson: $focalPerson
      notes: $notes
    ) {
      _id
    }
  }
`;

export const RE_ASSIGN_ISSUE_TO_POWER_USER = gql`
  mutation ReAssignIssueToPowerUser(
    $issue: ID!
    $powerUser: ID!
    $notes: String!
  ) {
    reAssignIssueToPowerUser(
      issue: $issue
      powerUser: $powerUser
      notes: $notes
    ) {
      _id
    }
  }
`;
